/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import AWS from 'aws-sdk';
import styles from './stand_activity.module.scss';
import Button from '../../components/button/button';
import { isLocal, hostName } from '../../constants/apiEnv';
import FormSubmitted from '../forms/components/FormSubmitted';
import CustomFields from '../../components/customFields/CustomFields';
import Loading from '../../components/loading';
import { getS3Region } from '../../utils/helpers';

const url = hostName.slice(6);
class StandActivityForm extends Component {
  constructor(props) {
      super(props);
      this.state={
        loadingStatus: false,
        apiStatus: undefined,
        showFormErrors: false,
        info: {},
        billingData: {},
        otherData: {},
        fieldType: '',
        spinloading: false,
        fieldErrors: {},
        successMessage: ''
      };
      const { match: { params: { id } } } = props;
      localStorage.setItem('portalBackendId', id);
      this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
  }

  componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
    this.setState({ loadingStatus: true });
    fetch(`${this.publicUrl}/gate_management/get_schema/${airportCode}`)
    .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw Error(response.statusText);
      })
    .then((data) => {
      const stand_form = data;
      this.getData(stand_form?.public_form_settings?.success_message_attachment);
      let fieldErrors1 = {};
      let temp_custom_default_fields = stand_form?.stand_request?.default_fields?.custom_default_fields?.filter(e => !e?.isDisabled);
      temp_custom_default_fields.forEach((ele) => { fieldErrors1 = { ...fieldErrors1, [ele?.id]: ele?.required }; });
      let fieldErrors2 = {};
      let temp_other_fields = (stand_form?.stand_request?.schema?.fields || [])?.filter(e => !e?.isDisabled);
      temp_other_fields.forEach((ele) => { fieldErrors2 ={ ...fieldErrors2, [ele?.id]: ele?.required }; });
      let fieldErrors = {};
      let temp_default_fields = stand_form?.stand_request?.default_fields?.default_fields?.filter(e => !e?.isDisabled);
      temp_default_fields?.forEach((ele) => { fieldErrors ={ ...fieldErrors, [ele?.id]: ele?.required }; });
      localStorage.setItem('timeFormat', data?.time_format === '24' ? 'HH:mm' : 'hh:mm A');
      localStorage.setItem('dateFormat', data?.date_format || 'MM/DD/YYYY');
      this.setState({
        loadingStatus: false,
        stand_form,
        fieldErrors: { ...fieldErrors, ...fieldErrors1, ...fieldErrors2 }
      });
    }).catch(() => {
      const message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        // apiStatus: true,
        loadingStatus: false
      });
    });
    this.getConfig();
  }

  handleFieldErrorChanged = (id, value) => {
    const { stand_form } = this.state;
    let { stand_request } = stand_form;
    let tempField = [
      ...(stand_request?.default_fields?.custom_default_fields || []),
      ...(stand_request?.default_fields?.default_fields || []),
      ...(stand_request?.schema?.fields || [])
    ]
    ?.filter(ele => ele?.id === id)?.[0];
    if (tempField && (tempField?.type === 'string' || tempField?.type === 'telephone') && tempField?.validators && tempField?.validators?.length > 0
    && tempField?.validators[0]?.value && (tempField?.validators[0]?.label === 'Email'
    || tempField?.validators[0]?.label === 'Phone Number' || tempField?.validators[0]?.label === 'Custom Validation')) return;
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  };

  getPhoneConvert = (answer) => {
    const countryCodeMatch = answer.match(/^\+([0-9]{1,3})[() -]/);
    const countryCodeLen = countryCodeMatch ? countryCodeMatch[1].length : 0;
    const convertValidtorValueToRegex = new RegExp(`^\\+[0-9]{${9+countryCodeLen},${10+countryCodeLen}}$`);
    const phoneValConvert = answer[0]+ answer.slice(1).replace(/[^\d]/g, '');
    return { phoneValConvert, convertValidtorValueToRegex };
  };

  handleAnswerChanged = (fieldId, answer, section) => {
    const { stand_form, fieldErrors } = this.state;
    let { stand_request } = stand_form;
    let tempField = {};
    if (section === 'info') {
      tempField = [...(stand_request?.default_fields?.default_fields || [])]?.filter(ele => ele?.id === fieldId)?.[0];
    } else if (section === 'billingData') {
      tempField = [...(stand_request?.default_fields?.custom_default_fields || [])]?.filter(ele => ele?.id === fieldId)?.[0];
    } else if (section === 'otherData') {
      tempField = [...(stand_request?.schema?.fields || [])]?.filter(ele => ele?.id === fieldId)?.[0];
    }
    this.setState(prevState => ({
      [section]: {
      ...prevState[section],
      [fieldId]: answer
      }
      }));
    if (tempField && tempField?.type === 'string' && tempField?.validators && tempField?.validators?.length > 0
      && tempField?.validators[0]?.value && tempField?.validators[0]?.type === 'Regex') {
      let regexVal = new RegExp(tempField?.validators[0]?.value);
      let cond = regexVal.test(answer);
      if ((tempField?.validators[0]?.label === 'Email' || tempField?.validators[0]?.label === 'Custom Validation') && typeof (cond) === 'boolean') {
        return this.setState(prevState => ({
          fieldErrors: {
            ...prevState.fieldErrors,
            [fieldId]: !cond
          }
        }));
      }
      const { phoneValConvert, convertValidtorValueToRegex } = this.getPhoneConvert(answer);
      let phoneCond = convertValidtorValueToRegex.test(phoneValConvert);
      if (tempField?.validators[0]?.label === 'Phone Number' && typeof (phoneCond) === 'boolean') {
        this.setState(prevState => ({
          fieldErrors: {
            ...prevState.fieldErrors,
            [fieldId]: !phoneCond
          }
        }));
      }
    }

    let fieldErrors1 = {};
    if (fieldId === 'billing_details') {
      let tempdefaultfields = [];
      if (answer === '3') {
        tempdefaultfields = stand_form?.stand_request?.default_fields?.custom_default_fields?.filter(e => !e?.isDisabled);
        tempdefaultfields.forEach((ele) => { fieldErrors1 = { ...fieldErrors1, [ele?.id]: false }; });
        this.setState({ billingData: {},
          fieldErrors: {
            ...fieldErrors,
            ...fieldErrors1
          }
        });
      } else {
        tempdefaultfields = stand_form?.stand_request?.default_fields?.custom_default_fields?.filter(e => !e?.isDisabled);
        tempdefaultfields.forEach((ele) => { fieldErrors1 ={ ...fieldErrors1, [ele?.id]: ele?.required }; });
        this.setState({
          fieldErrors: {
            ...fieldErrors,
            ...fieldErrors1
          }
        });
      }
    }
  };

  getRequired = (data) => {
    let requiredKeys = {};
    if (data) {
      data.forEach((ele) => {
        if (ele.required) {
          requiredKeys = { ...requiredKeys, [ele.id]: true };
        }
        if (ele.disabled) {
          requiredKeys = { ...requiredKeys, [ele.id]: false };
        }
        if (ele.required && ele?.default) {
          requiredKeys = { ...requiredKeys, [ele.id]: false };
        }
      });
      return requiredKeys;
      }
    };

    getData = (fileName) => {
      const { match: { params: { id: code } } } = this.props;
      const s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        region: getS3Region()
      });

      const params = {
        Bucket: `${process.env.REACT_APP_S3PREFIX}${code}-attachments/conditions/stand_activity`,
        Key: `${fileName}`,
        ResponseCacheControl: 'no-cache'
      };

      new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
          if (err) {
            return reject(err);
          }
          return resolve(data);
        });
      }).then((response) => {
        const info = response.Body.toString();
        this.setState({ successMessage: info });
      }).catch(() => {
        this.setState({ successMessage: '' });
      });
    };

  create = async () => {
    const { info, fieldErrors, billingData, stand_form, otherData } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    let noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
      );
    if (noErrors) {
      let billing_data = stand_form?.stand_request?.default_fields?.default_fields
        .find(ele => ele.id === 'billing_details')?.values
        .find(ele => ele.key === info.billing_details)?.value;
      let tempBilling_data = info?.billing_details === '3' ? {} : { ...billingData };
      let meta_data ={
            pilot_full_name: info?.full_name_pilot,
            pilot_number: info?.contact_number_pilot,
            pilot_email: info['pilot_e-mail'],
            billing_details: billing_data,
            ...tempBilling_data
           };
      let response = { ...otherData };
      this.setState({ loadingStatus: true });
      let infoData = info;
      infoData.tail_number = info.aircraft_registration;
      infoData.model_icao_code = info.aircraft_model;
      infoData.passengers_quantity = info.passengers_qty;
      infoData.arrival_timestamp = info.arrival_date;
      infoData.departure_timestamp = info.departure_date;
      delete infoData.aircraft_registration;
      delete infoData.aircraft_model;
      delete infoData.full_name_pilot;
      delete infoData.contact_number_pilot;
      delete infoData['pilot_e-mail'];
      delete infoData.billing_details;
      delete infoData.passengers_qty;
      delete infoData.arrival_date;
      delete infoData.departure_date;
      const data = {
        ...infoData,
        meta_data: {
            ...meta_data
        },
        response
      };

      try {
        await fetch(`${this.publicUrl}/gate_management/create_stand_request/${airportCode}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        })
        .then(res => res.json())
        .then(() => {
          this.setState({
            message: 'Your report has been submitted successfully.',
            apiStatus: true,
            loadingStatus: false
          });
        });
      } catch (error) {
        let message = 'There was a problem while submitting the form';
        if (error && error.detail) message = error.detail;
        this.setState({
          message,
          apiStatus: true,
          loadingStatus: false
        });
      }
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  getConfig = () => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION
    });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  };

render() {
   const { stand_form, info, billingData, apiStatus, message, successMessage, showFormErrors, otherData, loadingStatus, fieldErrors } = this.state;
   const standFields = stand_form?.stand_request?.default_fields?.default_fields;
   const standCustom = stand_form?.stand_request?.default_fields?.custom_default_fields;
   const standOther = stand_form?.stand_request?.schema?.fields;
   const standDescrption = stand_form?.public_form_settings;
return (
  <>
    <Loading loadingStatus={loadingStatus} />
    <div className={styles.Image}>
      <img src={stand_form?.airport_data?.image} alt="airport_logo" />
    </div>
    {!apiStatus && (
    <div className={styles.container}>
    <div className={styles.box}>
    <div className={styles.title}>
      <FormattedMessage
        id="sms.new.newHazards"
        defaultMessage="Stand Activity Public Form"
      />
    </div>
    <div style={{ padding: '0px 30px' }}>
  {/* eslint-disable-next-line react/no-danger */}
    <div className={styles.description} dangerouslySetInnerHTML={{ __html: standDescrption?.description }} />
    </div>
    <div className={styles.details_form}>
    <CustomFields
      handleAnswerChanged={(a, b) => this.handleAnswerChanged(b, a, 'info')}
      handleFieldErrorChanged={this.handleFieldErrorChanged}
      showFormErrors={showFormErrors}
      requiredMap={this.getRequired(standFields)}
      fields={standFields}
      answers={info}
      standform
      myforms
      standRequest
      fieldErrors={fieldErrors}
    />
    {(info.billing_details === '1' || info.billing_details === '2')
    && <CustomFields
        handleAnswerChanged={(a, b) => this.handleAnswerChanged(b, a, 'billingData')}
        handleFieldErrorChanged={this.handleFieldErrorChanged}
        showFormErrors={showFormErrors}
        requiredMap={this.getRequired(standCustom)}
        fields={standCustom}
        answers={billingData}
        standform
        myforms
        standRequest
        fieldErrors={fieldErrors}
    />
    }
    <CustomFields
      handleAnswerChanged={(a, b) => this.handleAnswerChanged(b, a, 'otherData')}
      handleFieldErrorChanged={this.handleFieldErrorChanged}
      showFormErrors={showFormErrors}
      requiredMap={this.getRequired(standOther)}
      fields={standOther}
      answers={otherData}
      standform
      myforms
      standRequest
      fieldErrors={fieldErrors}
    />
    </div>
    <div className={styles.footerSingle}>
      <div className={styles.saveBtns}>
        <div className={`${styles.footer} ${styles.embedded}`}>
          <Button
            action="secondary"
            onClick={() => this.create()}
            translationID="hazard.new.finish"
            defaultText="Create"
          />
        </div>
      </div>
    </div>
    </div>
    </div>
    )}
    {apiStatus && (
      <div className={`${styles.container} ${styles.formSubmitContainer}`}>
        <FormSubmitted name=""
          message={message} logo={stand_form?.airport_data?.imag}
          successMessage={successMessage}
        />
      </div>
    )}
  </>
);
}
}

export default StandActivityForm;
